import * as stylex from "@stylexjs/stylex";
import {
  colors,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";
export type CoworldHeaderStat = {
  readonly label: string;
  readonly value: string;
};

export function CoworldHeaderStats({
  stats,
  anchored,
}: {
  readonly stats: readonly CoworldHeaderStat[];
  readonly anchored: boolean;
}) {
  if (stats.length === 0) return null;

  return (
    <dl {...stylex.props(styles.stats, anchored && styles.statsTop)}>
      {stats.map((stat) => (
        <div key={stat.label} {...stylex.props(styles.stat)}>
          <dt {...stylex.props(styles.label)}>{stat.label}</dt>
          <dd {...stylex.props(styles.value)}>{stat.value}</dd>
        </div>
      ))}
    </dl>
  );
}

const wide = "@media (min-width: 640px)";

const styles = stylex.create({
  stats: {
    marginBottom: 0,
    marginInline: 0,
    gridColumnStart: { default: 1, [wide]: 2 },
    gridColumnEnd: { default: 3, [wide]: "auto" },
    gridRowStart: { default: 3, [wide]: 4 },
    marginTop: 14,
    display: "flex",
    flexWrap: "wrap",
    columnGap: { default: spacing.space16, [wide]: spacing.space24 },
    rowGap: spacing.space4,
  },
  statsTop: {
    gridColumnStart: 1,
    gridColumnEnd: 3,
    gridRowStart: 3,
    marginTop: spacing.space12,
  },
  stat: {
    display: "flex",
    alignItems: "baseline",
    gap: { default: spacing.space4, [wide]: spacing.space6 },
  },
  label: { fontSize: fontSizes.label, lineHeight: "20px", color: colors.muted },
  value: {
    margin: 0,
    fontSize: fontSizes.reading,
    lineHeight: "20px",
    fontWeight: 500,
    color: colors.foreground,
    fontVariantNumeric: "tabular-nums",
  },
});
